import React from "react";
import { MenuItem, useDisclosure, Spinner, Flex } from "@chakra-ui/react";
import { BiEditAlt } from "react-icons/bi";
import { Modal } from "components";
import { useToast, useInitializeOfflineData } from "duck";
import {
  GetUsersDocument,
  useGetUserQuery,
  User,
  useUpdateUserMutation,
  UserRoleEnum
} from "requests";
import { FormValues } from "../../duck";
import FormUser from "../form";
import { utils } from "./duck";

interface EditProps {
  _id: number;
}

interface InnerFormProps {
  _id: number;
  onClose(): void;
}

const InnerForm: React.FC<InnerFormProps> = ({ _id, onClose }) => {
  const toast = useToast();

  const { loadUsers } = useInitializeOfflineData();

  const [updateUser] = useUpdateUserMutation();
  const { data: userData } = useGetUserQuery({
    fetchPolicy: "no-cache",
    variables: { id: _id }
  });

  const { validationSchema, defaultValues } = utils.getValidation(
    userData?.user as User
  );

  const handleSubmit = (values: FormValues) =>
    updateUser({
      variables: {
        input: {
          _id,
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          ...(values.password && { plainPassword: values.password }),
          ...(values.pin && { plainPin: Number(values.pin) }),
          userRole: values.userRole as UserRoleEnum
        }
      },
      refetchQueries: [GetUsersDocument]
    }).then(data => {
      loadUsers();

      if (data) {
        onClose();
        toast({
          status: "success",
          description: "User is updated successfully."
        });
      }
    });

  if (!userData) {
    return (
      <Flex justifyContent="center" minH="200px" alignItems="center">
        <Spinner />
      </Flex>
    );
  }

  return (
    <FormUser
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      onClose={onClose}
    />
  );
};

const Edit: React.FC<EditProps> = ({ _id }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <MenuItem onClick={onOpen} icon={<BiEditAlt />}>
        Edit
      </MenuItem>
      <Modal title="Edit User" onClose={onClose} isOpen={isOpen}>
        {isOpen ? <InnerForm _id={_id} onClose={onClose} /> : null}
      </Modal>
    </>
  );
};

export default Edit;
